// Helper pur (sans dépendance React/Router) : extrait les fichiers image
// d'un évènement paste. Isolé ici pour être testable sous Jest sans charger
// AgentChat (qui importe react-router-dom).
export function imageFilesFromClipboard(clipboardData) {
  const items = (clipboardData && clipboardData.items) || [];
  const files = [];
  for (const it of items) {
    if (it.kind === "file" && it.type && it.type.startsWith("image/")) {
      const file = it.getAsFile();
      if (file) files.push(file);
    }
  }
  return files;
}

export function imageFileFromClipboard(clipboardData) {
  return imageFilesFromClipboard(clipboardData)[0] || null;
}
